<template>
	<div class="freight-estimate">
		<!-- 头部区域 -->
		<div class="fe-hero">
			<el-image class="fe-hero-bg" :src="require('@/static/CodeBuddyAssets/31120_1464/24.png')"></el-image>
			<!-- 描述文字 -->
			<div class="fe-desc">
				<p>{{$t('indexFreight.t1')}}</p>
			</div>
			<el-image class="fe-title-line" :src="require('@/static/CodeBuddyAssets/31120_1464/5.svg')"></el-image>
		</div>
		<!-- 查询区域 -->
		<div class="query-section animate__animated animate__fadeInUp">
			<div class="query-card">
				<div class="query-fields">
					<!-- 起运地 -->
					<div class="field-item">
						<div class="field-top">
							<span class="field-label">{{$t('indexFreight.t3')}}</span>
						</div>
						<div class="field-bottom">
							<!-- 多语言 -->
							<template v-if="$i18n.locale=='zh'">
								<el-select v-model="queryForm.warehouseId" :placeholder="$t('indexFreight.t4')" class="field-select">
									<el-option
										v-for="item in originOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</template>
							<template v-if="$i18n.locale=='en'">
								<el-select v-model="queryForm.warehouseId" :placeholder="$t('indexFreight.t4')" class="field-select">
									<el-option
										v-for="item in originOptions"
										:key="item.value"
										:label="item.nameEn"
										:value="item.value"
									></el-option>
								</el-select>
							</template>
							<el-image class="field-arrow" :src="require('@/static/CodeBuddyAssets/31120_1115/1.svg')"></el-image>
						</div>
					</div>
					<!-- 目的地 -->
					<div class="field-item country-field">
						<div class="field-top">
							<span class="field-label">{{$t('indexFreight.t5')}}</span>
						</div>
						<div class="field-bottom" @click="toggleCountryPanel">
							<span v-if="selectedCountryName" class="field-value">{{selectedCountryName}}</span>
							<span v-else class="field-placeholder">{{$t('indexFreight.t4')}}</span>
							<el-image class="field-arrow" :class="{ 'arrow-up': showCountryPanel }" :src="require('@/static/CodeBuddyAssets/31120_1115/1.svg')"></el-image>
						</div>
						<!-- 目的地弹出选择面板：搜索框 + 字母索引 -->
						<div class="country-panel" v-show="showCountryPanel" @click.stop>
							<div class="country-search">
								<el-input
									v-model="searchKeyword"
									:placeholder="$t('indexFreight.t29')"
									class="country-search-input"
									clearable>
									<i slot="prefix" class="el-icon-search"></i>
								</el-input>
							</div>
							<div class="country-body">
								<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
									<template v-for="group in filteredCountries">
										<div class="country-group" :key="group.letter" :data-letter="group.letter">
											<div class="country-group-title">{{group.letter}}</div>
											<div
												class="country-item"
												:class="{ active: queryForm.countryId === item.value }"
												v-for="item in group.items"
												:key="item.value"
												@click="selectCountry(item)">
												<!-- 多语言 -->
												<template v-if="$i18n.locale=='zh'">
													<span class="country-name">{{item.name}}</span>
												</template>
												<template v-if="$i18n.locale=='en'">
													<span class="country-name">{{item.nameEn}}</span>
												</template>
											</div>
										</div>
									</template>
									<div v-if="filteredCountries.length === 0" class="country-empty">{{$t('indexFreight.t30')}}</div>
								</div>
								<div class="country-index">
									<span
									v-for="letter in availableLetters"
									:key="letter"
									class="country-index-item"
									:class="{ active: activeLetter === letter }"
									@click="scrollToLetter(letter)">{{letter}}</span>
								</div>
							</div>
						</div>
					</div>
					<!-- 重量 -->
					<div class="field-item">
						<div class="field-top">
							<span class="field-required">*</span>
							<span class="field-label">{{$t('indexFreight.t6')}}(kg)</span>
						</div>
						<div class="field-bottom">
							<el-input v-model="queryForm.weight" type="number" class="field-input" :placeholder="$t('indexFreight.t7')"></el-input>
						</div>
					</div>
					<!-- 长宽高 -->
					<div class="field-item size-field">
						<div class="field-top">
							<span class="field-required">*</span>
							<span class="field-label">{{$t('indexFreight.t8')}}(cm)</span>
						</div>
						<div class="field-bottom size-inputs">
							<el-input v-model="queryForm.length" type="number" class="size-input" :placeholder="$t('indexFreight.t9')"></el-input>
							<el-input v-model="queryForm.width" type="number" class="size-input" :placeholder="$t('indexFreight.t10')"></el-input>
							<el-input v-model="queryForm.height" type="number" class="size-input" :placeholder="$t('indexFreight.t11')"></el-input>
						</div>
					</div>
					<div class="query-btn" @click="submit">{{$t('indexFreight.t12')}}</div>
				</div>
			</div>
		</div>

		<!-- 结果列表 -->
		<div class="fe-results animate__animated animate__fadeInUp">
			
			<div class="zwBox" v-if="!resultList.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>{{$t('indexFreight.t122')}}</p>
			</div>
			
			<div v-for="(item, index) in resultList" :key="index" class="result-card">
				<div class="rc-main">
					<div class="rc-origin">
						<div class="loc-icon-wrap">
							<el-image class="loc-icon" :src="require('@/static/CodeBuddyAssets/31120_1464/12.svg')"></el-image>
							<span class="loc-badge">{{$t('indexFreight.t31')}}</span>
						</div>
						<div class="loc-info">
							<div class="loc-name-row">
								<span class="loc-name">{{pageMsg.warehouse.name}}</span>
								<span class="loc-country">{{ pageMsg.warehouse.countryName }}</span>
							</div>
							<span class="loc-type">{{$t('indexFreight.t13')}}</span>
						</div>
					</div>
					<div class="rc-arrow">
						<el-image :src="require('@/static/CodeBuddyAssets/31120_1464/11.svg')"></el-image>
					</div>
					<div class="rc-dest">
						<div class="loc-icon-wrap">
							<el-image class="loc-icon" :src="require('@/static/CodeBuddyAssets/31120_1464/10.svg')"></el-image>
							<span class="loc-badge dest-badge">{{$t('indexFreight.t32')}}</span>
						</div>
						<div class="loc-info">
							<div class="loc-name-row">
								<span class="loc-name">{{pageMsg.country.name}}</span>
								<!-- <span class="loc-country">{{pageMsg.country.name}}</span> -->
							</div>
							<span class="loc-type">{{$t('indexFreight.t14')}}</span>
						</div>
					</div>
					<div class="rc-detail-col">
						<div class="f-ct info-pairw">
							<div class="info-pair">
								<span class="info-label">{{$t('indexFreight.t15')}}：</span><span class="info-value">{{ queryForm.weight }}kg</span>
							</div>
							<div class="info-pair">
								<span class="info-label">{{$t('indexFreight.t16')}}：</span><span class="info-value">{{ pageMsg.weight }}kg</span>
							</div>
						</div>
						<div class="f-ct info-pairw">
							<div class="info-pair">
								<span class="info-label">{{$t('indexFreight.t17')}}：</span><span class="info-value">{{ pageMsg.volume }}m³</span>
							</div>
							<div class="info-pair">
								<span class="info-label">{{$t('indexFreight.t18')}}：</span><span class="info-value">{{ pageMsg.volume }}m³</span>
							</div>
						</div>
					</div>
					<div class="rc-price-area">
						<div class="price-text">
							<span class="price-symbol">￥</span>
							<span class="price-num">{{ item.freightPrice }}</span>
						</div>
					</div>
					<div class="rc-actions">
						<button class="action-btn detail-btn" @click="link('/freightDetail',{id:item.id})">{{$t('indexFreight.t19')}}</button>
						<button class="action-btn order-btn" @click="link('/userPageLab/orderPage')">{{$t('indexFreight.t20')}}</button>
					</div>
				</div>
				<div class="rc-footer">
					<span class="user-note">{{$t('indexFreight.t21')}}：{{ item.description }}</span>
					<div class="channel-tag">
						<span>{{$t('indexFreight.t22')}}：</span>
						<span class="channel-val">{{ item.name }}</span>
					</div>
				</div>
			</div>
			
			<!-- Element-UI 分页器 -->
			<div v-if="resultList.length" class="pagination-wrap">
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:total="total"
					:page-size="pageSize"
					:current-page.sync="currentPage"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>

			<!-- 查看更多 -->
			<!-- <div class="view-more">
				<span>查看更多</span>
				<el-image :src="require('@/static/CodeBuddyAssets/31120_1464/21.svg')"></el-image>
			</div> -->
			
		</div>

	</div>
</template>

<script>
import {
	countrylist,
	warehouselist,
	freightEstimateLineDetail,
	freightEstimateLineList,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
const CN_FIRST_LETTER = {
	'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
	'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
	'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
	'布': 'B',
	'赤': 'C',
	'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
	'俄': 'E', '厄': 'E',
	'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
	'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
	'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
	'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
	'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
	'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
	'列': 'L', '卢': 'L', '罗': 'L',
	'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
	'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
	'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
	'帕': 'P', '葡': 'P',
	'日': 'R', '瑞': 'R',
	'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
	'索': 'S',
	'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
	'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
	'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
	'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
	'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
	'赞': 'Z', '智': 'Z', '中': 'Z'
}
export default {
	name: 'FreightEstimate',
	data() {
		return {
			// 分页
			currentPage: 1,
			pageSize: 10,
			total: 1,
			// 查询表单数据
			queryForm: {
				warehouseId: '',
				countryId: '',
				weight: '',
				length: '',
				width: '',
				height: ''
			},
			// 起运地选项列表
			originOptions: [],
			// 目的地选项列表
			destinationOptions: [],
			// 国家选择面板
			searchKeyword: '',
			showCountryPanel: false,
			activeLetter: '',
			// 数据
			pageMsg:'',
			resultList: [],
			// 当前选中目的地名称
			selectedCountryName:'',
		}
	},
	computed: {
		...mapState('userMsg',['userInfo','token','jisuan']),
		// 当前选中目的地名称
		// selectedCountryName() {
		// 	console.log(this.destinationOptions)
		// 	const item = this.destinationOptions.find(o => o.value === this.queryForm.countryId)
		// 	return this.queryForm.countryId
		// },
		// 按首字母分组 + 搜索过滤后的列表
		filteredCountries() {
			const kw = this.searchKeyword.trim().toLowerCase()
			let list = this.destinationOptions
			if (kw) {
				list = list.filter(item => {
					const name = String(item.label || item.name || '').toLowerCase()
					return name.indexOf(kw) > -1
				})
			}
			return this.groupByLetter(list)
		},
		// 字母索引条：基于全部国家（不随搜索变化）
		availableLetters() {
			const set = []
			this.destinationOptions.forEach(item => {
				const l = this.getFirstLetter(item.label || item.name)
				if (set.indexOf(l) === -1) set.push(l)
			})
			return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
		}
	},
	watch:{
		showCountryPanel() {
			const item = this.destinationOptions.find(o => o.value === this.queryForm.countryId)
			// 多语言
			if(this.$i18n.locale=='zh'){
				this.selectedCountryName = item.name
			}
			if(this.$i18n.locale=='en'){
				this.selectedCountryName = item.nameEn
			}
		},
	},
	mounted() {
		this.queryForm = {...this.jisuan}
		this.countrylistF()
		document.addEventListener('click', this.handleDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick)
	},
	methods: {
		// ===== 国家选择面板相关 =====
		// 切换面板显示状态
		toggleCountryPanel() {
			this.showCountryPanel = !this.showCountryPanel
			if (this.showCountryPanel) {
				this.searchKeyword = ''
				this.activeLetter = ''
			}
		},
		// 选中国家
		selectCountry(item) {
			this.queryForm.countryId = item.value
			this.showCountryPanel = false
			this.searchKeyword = ''
		},
		// 点击字母索引，锚定滚动到对应分组
		scrollToLetter(letter) {
			this.activeLetter = letter
			const listEl = this.$refs.countryList
			if (!listEl) return
			const target = listEl.querySelector(`[data-letter="${letter}"]`)
			if (target) {
				listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		// 列表滚动时高亮当前所在字母
		onCountryListScroll() {
			const listEl = this.$refs.countryList
			if (!listEl) return
			const scrollTop = listEl.scrollTop
			let current = ''
			listEl.querySelectorAll('[data-letter]').forEach(el => {
				if (el.offsetTop <= scrollTop + 1) {
					current = el.getAttribute('data-letter')
				}
			})
			this.activeLetter = current
		},
		// 提取首字母（兼容英文/中文，无法识别归入 #）
		getFirstLetter(name) {
			if (!name) return '#'
			const first = String(name).trim().charAt(0)
			if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
			if (/[\u4e00-\u9fa5]/.test(first)) {
				return CN_FIRST_LETTER[first] || '#'
			}
			return '#'
		},
		// 按首字母分组
		groupByLetter(list) {
			const groups = {}
			list.forEach(item => {
				const letter = this.getFirstLetter(item.label || item.name)
				if (!groups[letter]) groups[letter] = []
				groups[letter].push(item)
			})
			const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			return letters.map(l => ({ letter: l, items: groups[l] }))
		},
		// 点击面板外部关闭
		handleDocumentClick(e) {
			if (!this.showCountryPanel) return
			const field = this.$el.querySelector('.country-field')
			if (field && !field.contains(e.target)) {
				this.showCountryPanel = false
			}
		},
		// 表单验证
		validate(){
			// console.log('查询参数：', this.queryForm)
			if (!this.queryForm.warehouseId) {
				this.Tips(this.$t('indexFreight.t23'),'error')
				return false;
			}
			if (!this.queryForm.countryId) {
				this.Tips(this.$t('indexFreight.t24'),'error')
				return false;
			}
			if (!this.queryForm.weight) {
				this.Tips(this.$t('indexFreight.t25'),'error')
				return false;
			}
			if (!this.queryForm.length) {
				this.Tips(this.$t('indexFreight.t26'),'error')
				return false;
			}
			if (!this.queryForm.width) {
				this.Tips(this.$t('indexFreight.t27'),'error')
				return false;
			}
			if (!this.queryForm.height) {
				this.Tips(this.$t('indexFreight.t28'),'error')
				return false;
			}
			return true
		},
		// 提交
		async submit(){
			if(!this.validate()){return}
			var res;
			res = await freightEstimateLineDetail({...this.queryForm});
			if(res.code==200){
				this.pageMsg = res.data
				this.$store.commit('userMsg/jisuanC','');
				this.$store.commit('userMsg/jisuanMsgC',res.data);
				this.submitList()
			}else{this.Tips(res.msg,'error')}
		},
		async submitList(){
			var res;
			res = await freightEstimateLineList({
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				warehouseId:this.queryForm.warehouseId,
				countryId:this.queryForm.countryId,
				weight:this.queryForm.weight,
			});
			if(res.code==200){
				this.total = res.total
				this.resultList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 切换分页
		handleCurrentChange(e){
			this.submitList()
		},
		// 运输路线列表
		async transportLinelineListF(){
			var res;
			res = await transportLinelineList({});
			if(res.code==200){
				this.lineArr = res.rows
				this.activeTab = res.rows[0].id
			}else{this.Tips(res.msg,'error')}
		},
		// 国家列表(全部启用的)
		async countrylistF(){
			var res;
			res = await countrylist({});
			if(res.code==200){
				var destinationOptions = []
				res.rows.forEach((item)=>{
					destinationOptions.push({
						...item,
						label:item.name,
						value:item.id,
					})
				})
				this.destinationOptions = destinationOptions
				
				const item = this.destinationOptions.find(o => o.value === this.queryForm.countryId)
				// 多语言
				if(this.$i18n.locale=='zh'){
					this.selectedCountryName = item.name
				}
				if(this.$i18n.locale=='en'){
					this.selectedCountryName = item.nameEn
				}
				
				this.warehouselistF()
			}else{this.Tips(res.msg,'error')}
		},
		// 仓库列表(全部正常的)
		async warehouselistF(){
			var res;
			res = await warehouselist({});
			if(res.code==200){
				var originOptions = []
				res.rows.forEach((item)=>{
					originOptions.push({
						...item,
						label:item.name,
						value:item.id,
					})
				})
				this.originOptions = originOptions
				if(this.jisuan.warehouseId){
					this.submit()
				}
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
.freight-estimate {
	width: 100%;
	background: #F8F8F8;
	position: relative;
	padding-bottom: 54px;
}

/* ===== 头部 Hero ===== */
.fe-hero {
	position: relative;
	width: 100%;
	height: 4.00rem;
	background: #0096FF;
	overflow: hidden;
}
.fe-hero-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 400px;
	object-fit: cover;
}

/* 描述文字 */
.fe-desc {
	position: absolute;
	top: 198px;
	left: 50%;
	transform: translateX(-50%);
	text-align: center;
	width: 1268px;
	p {
		color: #fff;
		font-size: 20px;
		font-weight: 500;
		line-height: 1.6;
	}
}
.fe-title-line {
	position: absolute;
	top: 112px;
	left: 832px;
}

/* ===== 查询表单 ===== */
.query-section {
	position: relative;
	width: 14.60rem;
	margin: -0.85rem auto 0;
	z-index: 10;
}
.query-tabs {
	display: flex;
	padding-left: 1.44rem;
	.tab-item {
		color: #fff;
		font-size: 0.17rem;
		font-weight: 500;
		padding: 0.14rem 0.24rem;
		cursor: pointer;
		transition: all 0.3s;
		&.active {
			background: #fff;
			color: #0096FF;
			border-top-left-radius: 0.06rem;
			border-top-right-radius: 0.06rem;
		}
		&:hover:not(.active) {
			opacity: 0.8;
		}
	}
}
.query-card {
	background: #fff;
	box-shadow: 0 0.02rem 0.16rem rgba(0,0,0,0.05);
	border-radius: 0.08rem 0.08rem;
	padding: 0.32rem 0.24rem;
}
.query-fields {
	display: flex;
	align-items: flex-end;
	gap: 0.16rem;
}
.field-item {
	flex: 1;
	min-width: 0;
	border: 0.01rem solid #E2E6E9;
	border-radius: 0.05rem;
	padding: 0.09rem 0.18rem;
	height: 0.69rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	transition: border-color 0.3s, box-shadow 0.3s;
	position: relative;
	&:hover {
		border-color: #0096FF;
		box-shadow: 0 0 0.02rem rgba(0,150,255,0.15);
	}
	.field-top {
		display: flex;
		align-items: center;
		position: absolute;
		background: #fff;
		top: 0;
		padding: 0 0.1rem;
		transform: translateY(-50%);
		.field-icon {
			margin-right: 0.04rem;
		}
		.field-required {
			color: #FC1E0E;
			font-size: 0.14rem;
			font-weight: 500;
		}
		.field-label {
			color: #92969F;
			font-size: 0.14rem;
			font-weight: 500;
		}
	}
	.field-bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 0.69rem;
		.field-value {
			color: #333;
			font-size: 0.16rem;
			font-weight: 500;
		}
		.field-placeholder {
			color: #BFC6CE;
			font-size: 0.16rem;
			font-weight: 500;
		}
		.field-arrow {
			cursor: pointer;
		}
		/* 下拉选择框样式 */
		.field-select {
			width: 100%;
			padding-left: 4px;
			::v-deep .el-input__inner {
				border: none;
				padding: 0;
				font-size: 0.16rem;
				color: #333;
				background: transparent;
				cursor: pointer;
			}
			::v-deep .el-input__suffix{
				display: none;
			}
			.el-input__suffix {
				.el-select__caret {
					color: #999;
					font-size: 0.12rem;
				}
			}
		}
		/* 文本输入框样式 */
		.field-input {
			flex: 1;
			width: 100%;
			::v-deep .el-input__inner {
				border: none;
				padding: 0;
				padding-left: 8px;
				font-size: 0.16rem;
				color: #333;
				background: transparent;
				caret-color: #0096FF;
				box-shadow: none;
			}
			.el-input__inner::placeholder {
				color: #BFC6CE;
				font-weight: 500;
			}
		}
	}
	.size-inputs {
		display: flex;
		justify-content: space-between;
		gap: 0.12rem;
		.size-input {
			flex: 1;
			min-width: 0;
			::v-deep .el-input__inner {
				border: none;
				padding: 0.06rem 0.06rem;
				font-size: 0.16rem;
				color: #333;
				// text-align: center;
				background: #FAFBFC;
				border-radius: 0.04rem;
				caret-color: #0096FF;
				box-shadow: none;
				transition: background-color 0.3s, box-shadow 0.3s;
			}
			.el-input__inner::placeholder {
				color: #BFC6CE;
				font-weight: 500;
			}
			.is-focus .el-input__inner,
			.el-input:focus .el-input__inner {
				background: #fff;
				box-shadow: 0 0 0.02rem rgba(0,150,255,0.15);
			}
		}
	}
}
.query-btn {
	width: 2.03rem;
	height: 0.70rem;
	background: #0096FF;
	border-radius: 0.05rem;
	color: #fff;
	font-size: 0.18rem;
	font-weight: 500;
	text-align: center;
	line-height: 0.70rem;
	cursor: pointer;
	flex-shrink: 0;
	transition: all 0.3s;
	&:hover {
		background: #33ABFF;
		box-shadow: 0 0.04rem 0.12rem rgba(0,150,255,0.4);
		transform: translateY(-0.02rem);
	}
	&:active {
		background: #0081D9;
		transform: translateY(0);
	}
}
/* ===== 结果列表 ===== */
.fe-results {
	width: 1460px;
	margin: 50px auto 0;
	padding-bottom: 80px;
	
	background: #fff;
	padding: 30px;
	border-radius: 16px;
}
.result-card {
	background: #FAFCFE;
	border-radius: 8px;
	overflow: hidden;
	margin-bottom: 24px;
	transition: box-shadow 0.3s;
	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
	}
}
.rc-main {
	display: flex;
	align-items: center;
	padding: 22px 33px;
	position: relative;
}

/* 始发地 / 目的地 */
.rc-origin,
.rc-dest {
	display: flex;
	align-items: flex-start;
	min-width: 120px;
	.loc-icon-wrap {
		width: 16px;
		height: 16px;
		position: relative;
		flex-shrink: 0;
		margin-top: 3px;
		.loc-icon {
			width: 100%;
			height: 100%;
		}
		.loc-badge {
			position: absolute;
			top: 1px;
			left: 3px;
			color: #fff;
			font-size: 10px;
			font-family: PingFang SC;
			font-weight: 400;
		}
	}
	.loc-info {
		margin-left: 6px;
		.loc-name-row {
			// display: flex;
			align-items: center;
			.loc-name {
				color: #333;
				font-size: 16px;
				font-weight: 500;
			}
			.loc-country {
				color: #9CA4BA;
				font-size: 14px;
				font-weight: 500;
				margin-left: 7px;
				margin-top: -2px;
			}
		}
		.loc-type {
			color: #9A9C9A;
			font-size: 14px;
			font-weight: 400;
			margin-top: 6px;
			display: inline-block;
		}
	}
}

/* 箭头 */
.rc-arrow {
	display: flex;
	align-items: center;
	margin: 0 54px;
	// padding-top: 18px;
	img { display: block; }
}

/* 详情信息列 */
.rc-detail-col{
	// display: flex;
	// flex-direction: column;
	// gap: 2px;
	margin-left: 85px;
	.info-pairw{
		display: flex;
		width: 100%;
		margin-bottom: 12px;
		&:last-child{
			margin-bottom: 0px;
		}
		.info-pair {
			width: 50%;
			.info-label {
				color: #9CA4BA;
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
			}
			.info-value {
				color: #333;
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
			}
		}
	}
	
}
.rc-detail-col { 
	// background: pink;
	width: 400px;
	margin-right: 100px;
}


/* 价格 */
.rc-price-area {
	display: flex;
	align-items: center;
	margin-right: 24px;
	.price-text {
		.price-symbol {
			color: #FC2933;
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 500;
		}
		.price-num {
			color: #FC2933;
			font-size: 24px;
			font-family: MiSans, sans-serif;
			font-weight: 500;
		}
	}
}

/* 操作按钮 */
.rc-actions {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-left: auto;
	.action-btn {
		width: 120px;
		height: 46px;
		border-radius: 6px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s;
		border: none;
	}
	.detail-btn {
		background: transparent;
		border: 1px solid #C6C6C6;
		color: #333;
		&:hover { border-color: #0096FF; color: #0096FF; }
	}
	.order-btn {
		background: #0096FF;
		color: #fff;
		&:hover {
			background: #33ABFF;
			box-shadow: 0 4px 12px rgba(0, 150, 255, 0.35);
		}
	}
}

/* 底部描述条 */
.rc-footer {
	margin: 0 3px;
	height: 40px;
	background: linear-gradient(90deg, #E6F5FF 0%, #FAFCFE 100%);
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 30px;
	.user-note {
		color: #333;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
	}
	.channel-tag {
		span:first-child {
			color: #333;
			font-size: 15px;
			font-family: PingFang SC;
			font-weight: 500;
		}
		.channel-val {
			color: #0096FF;
			font-size: 15px;
			font-family: PingFang SC;
			font-weight: 500;
		}
	}
}

/* 查看更多 */
.view-more {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 48px;
	cursor: pointer;
	padding-bottom: 12px;
	span {
		color: #0096FF;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
	}
	img { margin-left: 4px; }
}

/* ===== Element-UI 分页器样式 ===== */
::v-deep .el-pagination.is-background .el-pager li{
	background: transparent;
}
::v-deep .el-pagination.is-background .btn-prev{
	background: transparent;
}
::v-deep .el-pagination.is-background .btn-next{
	background: transparent;
}
.pagination-wrap {
	width: 13.36rem;
	margin: 0 auto;
	padding-top: 0.30rem;
	padding-bottom: 0.3rem;
	display: flex;
	justify-content: center;
	::v-deep .el-pagination__editor {
		margin-right: 12px;
	}
	::v-deep .el-pagination {
		font-weight: 400;
		.el-pager li {
			min-width: 0.32rem;
			height: 0.32rem;
			line-height: 0.32rem;
			font-size: 0.14rem;
			border-radius: 0.04rem;
			margin: 0 0.02rem;
			color: #333;
			&.active {
				background: #0096FF;
				color: #fff;
				border-color: #0096FF;
			}
			&:hover {
				color: #0096FF;
			}
		}
		.el-pagination__total {
			font-size: 0.14rem;
			color: #999;
			margin-right: 0.12rem;
		}
		.btn-prev, .btn-next {
			min-width: 0.32rem;
			height: 0.32rem;
			line-height: 0.32rem;
			font-size: 0.14rem;
			border-radius: 0.04rem;
			&:hover { color: #0096FF; }
		}
		.el-pagination__jump {
			font-size: 0.14rem;
			color: #999;
			margin-left: 0.12rem;
			.el-input__inner {
				width: 0.50rem;
				height: 0.32rem;
				line-height: 0.32rem;
				font-size: 0.14rem;
				border-radius: 0.04rem;
				&:focus { border-color: #0096FF; }
			}
		}
	}
}

/* ===== 目的地国家选择面板 ===== */
.country-field {
	overflow: visible;
}
.field-arrow {
	transition: transform 0.3s;
	&.arrow-up {
		transform: rotate(180deg);
	}
}
.country-panel {
	position: absolute;
	top: calc(100% + 0.06rem);
	left: 0;
	width: 7.2rem;
	background: #fff;
	border-radius: 0.08rem;
	box-shadow: 0 0.08rem 0.32rem rgba(0, 0, 0, 0.16);
	z-index: 999;
	padding: 0.16rem;
	box-sizing: border-box;
}
.country-search {
	margin-bottom: 0.12rem;
	.country-search-input {
		::v-deep .el-input__inner {
			height: 0.4rem;
			border: 0.01rem solid #E2E6E9;
			border-radius: 0.04rem;
			padding-left: 0.3rem;
			font-size: 0.14rem;
			color: #333;
		}
		::v-deep .el-input__inner:focus {
			border-color: #0096FF;
		}
		::v-deep .el-input__prefix {
			left: 0.08rem;
			line-height: 0.4rem;
			color: #92969F;
		}
	}
}
.country-body {
	display: flex;
	align-items: flex-start;
}
.country-list {
	flex: 1;
	height: 3.2rem;
	overflow-y: auto;
	padding-right: 0.08rem;
	position: relative;
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 2px;
	}
}
.country-group-title {
	font-size: 0.13rem;
	font-weight: 600;
	color: #0096FF;
	padding: 0.06rem 0.1rem;
}
.country-item {
	padding: 0.08rem 0.1rem;
	font-size: 0.14rem;
	color: #333;
	cursor: pointer;
	border-radius: 0.04rem;
	transition: background 0.2s, color 0.2s;
	&:hover {
		background: #F0F7FD;
		color: #0096FF;
	}
	&.active {
		background: #F0F7FD;
		color: #0096FF;
		font-weight: 500;
	}
}
.country-empty {
	text-align: center;
	color: #BFC6CE;
	font-size: 0.14rem;
	padding: 0.4rem 0;
}
.country-index {
	width: 0.36rem;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 3.2rem;
	overflow-y: auto;
	border-left: 0.01rem solid #F0F0F0;
}
.country-index-item {
	font-size: 0.12rem;
	color: #666;
	cursor: pointer;
	line-height: 1.4;
	padding: 0.01rem 0;
	transition: color 0.2s;
	&:hover,
	&.active {
		color: #0096FF;
		font-weight: 600;
	}
}
</style>
